import { Icon, IconNameEnum, IconTypeEnum } from "../Icon";

import styles from "./TableCellWithRightArrow.module.scss";

interface ITableCellWithRightArrowProps {
  mainComponent: React.ReactNode;
  rightComponent?: React.ReactNode;
}

export const TableCellWithRightArrow: React.FC<ITableCellWithRightArrowProps> = ({ mainComponent, rightComponent }) => {
  return (
    <div className={styles.container}>
      {mainComponent}
      <div className={styles.rightSection}>
        {rightComponent && rightComponent}
        <Icon name={IconNameEnum.chevronRight} type={IconTypeEnum.default} />
      </div>
    </div>
  );
};
